import store from '@/store'

export default [
  {
    path: '/score-components',
    name: 'score-component',
    meta: { requiresAuth: true },
    component: () => import('@/pages/score-component/index.vue')
  }
]
